import { Component } from "@angular/core";
import { Subject } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-merchant-audit-view",
  templateUrl: "./merchant-audit-view.component.html",
  styleUrls: ["./merchant-audit-view.component.scss"],
})
export class MerchantAuditViewComponent {
  private _destroyed$ = new Subject<any>();
  public merchantNumber: string;

  constructor(private _route: ActivatedRoute) {
    _route.params
      .pipe(takeUntil(this._destroyed$))
      .subscribe(async (params) => {
        this.merchantNumber = params.id;
      });
  }
}
